export default __webpack_public_path__ + "520b9163244b1513e5d2ad074a990927.png";